import type { Metadata } from "next";
import { CompatTool } from "@/components/compat-tool";

export const metadata: Metadata = {
  title: "Hợp Tuổi Làm Ăn — Tử Vi Số",
  description: "Xem hợp tuổi đối tác kinh doanh — trọng số nghiêng về Mệnh và Cung Phi.",
};

type Props = { searchParams: Promise<{ y1?: string; g1?: string; y2?: string; g2?: string }> };

export default async function HopTuoiLamAn({ searchParams }: Props) {
  const sp = await searchParams;
  return (
    <CompatTool
      searchParams={sp}
      mode="business"
      title="Hợp Tuổi Làm Ăn"
      hint="Hợp tuổi đối tác kinh doanh — nặng yếu tố Mệnh và Cung Phi."
    />
  );
}
